import { useAppContext } from "../context/appContext/appContext";
import { Navigate } from "react-router-dom";

import Loading from "../components/Loading.js";

const ProtectedRoute = ({ children }) => {
  const { user, userLoading } = useAppContext();
  if (userLoading) return <Loading />;
  if (!user) {
    return <Navigate to="/" />;
  }
  return children;
};
export default ProtectedRoute;
